import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Price } from "./__simple/_price";
import { CountdownCalendar } from '../pages/parts/components/countdownCalendar';
import config from "../configuration/config";
import { Base64 } from 'js-base64';
function Offer({
    img = "/assets/images/offers/1.png",
    name = "اسم العرض هنا",
    type,
    excerpt,
    showSeconds = true,
    slug,
    price,
    endDate,
    startDate,
    totalDays = 0
}) {
    const { t: trans, i18n } = useTranslation(["common", "new"]);
    const languageDir = "language-" + (i18n.language || 'ar');
    return (
        <Link to={(type === "Vehicles" || type === "المركبات") ? "offers/vehicles/" + slug : "offers/detail/" + slug}
            onClick={() => {
                import("../services/trackingUserEvents").then(tracking => {
                    tracking.trackSelectPromotion({
                        promotion_id: slug,
                        promotion_name: name,
                        creative_name: "offer_section",
                        creative_slot: "offer_section_slot",
                        location_id: "offer_section_location",
                    });
                });
            }}
            className={"ofc " + languageDir}
        >
            <div className="ofc-img">
                <div className="ofc-badge new"><span className="pdot"></span>{trans("common:new")}</div>
                {

                    (img && Base64.isValid(img) === 1 ?

                        <img className="lazyload" width={211} height={123} data-src={img ? "data:image/png;base64," + img : "/assets/images/default.png"}
                            alt={name} /> :
                        <img className="lazyload" width={211} height={123} data-src={img ? config.FilePathURL + img : "/assets/images/default.png"}
                            alt={name} />)
                }
            </div>
            <div className="ofc-body">
                <div className="ofc-title">{name}</div>
                <div className="ofc-desc">{excerpt}</div>
                <div className="ofc-foot">
                    <div className="ofc-timer">
                        <CountdownCalendar showSeconds={showSeconds} Total={totalDays} start={startDate} endDate={endDate} />
                    </div>
                    {price && (
                        <p className={"text-primary font-bold text-16 mx-2"}>
                            <Price price={price} className="text-2xl text-[#23cc4f]" />
                        </p>
                    )}
                    <button className="ofc-cta">{trans("common:show-more")}</button>
                </div>
            </div>
        </Link>
    );
}

export default Offer;